export const A6_TEMPLATE_CANVAS = {
    width: 420,
    height: 592
} as const;

export const A6_TEMPLATE_UNITS_PER_MM = 4;
